import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  content: {
    height: '100%',
    width: '100%',
    top: 0,
    position: 'absolute',
    padding: ['17vh', theme.spacing(3), theme.spacing(3), 20],
    [theme.breakpoints.up('md')]: {
      paddingLeft: 70,
      paddingRight: 70,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 1690,
      margin: [0, 'auto'],
      position: 'relative',
      padding: ['18vh', 140, theme.spacing(3)],
    },
  },
  image: {
    display: 'none',
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      position: 'absolute',
      height: '63vh',
      bottom: '21vh',
      right: 120,
    },
  },
  title: {
    color: theme.palette.colors.darkBlue,
    fontFamily: 'Playfair Display',
    fontSize: theme.spacing(4),
    lineHeight: '124%',
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    [theme.breakpoints.up('lg')]: {
      fontSize: 48,
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: theme.spacing(8),
      lineHeight: '116%',
    },
  },
  subtitle: {
    color: '#607D8B',
    fontSize: theme.spacing(2),
    lineHeight: '148%',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.spacing(3),
    },
    [theme.breakpoints.up('xl')]: {
      fontSize: theme.spacing(4),
      lineHeight: '124%',
      marginBottom: 40,
    },
  },
  buttonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    padding: [theme.spacing(1), theme.spacing(3)],
    fontSize: theme.spacing(2),
    height: theme.spacing(6),
    boxShadow: 'rgb(38 166 154 / 80%) 0px 10px 40px -10px',
    [theme.breakpoints.up('lg')]: {
      padding: [theme.spacing(2), theme.spacing(4)],
      fontSize: theme.spacing(3),
      height: theme.spacing(8),
    },
    '&:hover': {
      color: theme.palette.colors.white,
      boxShadow: 'rgb(38 166 154 / 80%) 0px 10px 40px -10px',
    },
    '&:focus': {
      color: theme.palette.colors.white,
      outline: 'none',
      textDecoration: 'none',
    },
  },
  buttonIcon: {
    fill: theme.palette.colors.white,
    marginLeft: 19,
  },
}));



// WEBPACK FOOTER //
// ./src/components/NonAuthHomePage/components/Banner/useStyles.js